<template>
	<div id="idFrmPan" ref="idFrmPan" style="display:flex; flex-direction:column; border:0px solid blue; height:100%;">
		<popwin style="width:100%; height:100%;" :ctrl="ctrlWin"></popwin>

		<div style="flex: 0 0 auto; width:100%; height:50px;">
			<div class="SiftPanel">
				<div class="NButton DIVNoSelect" style="width:70px; margin-top:-1px; margin-left:10px;" @click="onTemplateAddClick">{{getLangText('新增')}}</div>

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('模板名称')}}</div>
				<input type="text" style="width:200px;" v-model="findTemplateName">

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('模板类型')}}</div>
				<cselect :key="KeyModel" style="position:relative; height:30px; min-width:200px; z-index:999;" :defv="findModelType" v-model="findModelType" :ctrl="ctrlModelType" :csData="dataModelType"></cselect>

				<div class="Capt DIVNoSelect" style="flex:0 0 auto; margin-top:-1px; margin-left:20px;">{{getLangText('发布状态')}}</div>
				<cselect style="position:relative; height:30px; min-width:150px; z-index:999;" :defv="findPublish" v-model="findPublish" :ctrl="ctrlPublish" :csData="dataPublish"></cselect>

				<check style="height:30px; margin-right:10px; margin-left:30px;" :size="18" :grpName="'GrpRange'" :val="2" :capt="getLangText('私有')" :checked="chkPrivate" :key="KeyPrivate"></check>
				<check style="height:30px; margin-right:20px;"                   :size="18" :grpName="'GrpRange'" :val="1" :capt="getLangText('共享')" :checked="chkShare"   :key="KeyShare"></check>

				<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onTemplaListClick"></div>
			</div>
		</div>
		<div style="flex: 1 0 auto; width:100%; border:0px solid red; " id="idListPan" ref="idListPan">
			<div style="flex:1 0 auto; width:100%; height:100%; border:0px solid red; display:flex; flex-direction:row; flex-wrap:wrap; overflow-y:auto;" :key="KeyList">
				<div style="flex:0 0 auto; width:254px; height:337px; border:1px solid #bbbbbb; margin-left:70px; margin-top:40px; position:relative; z-index:900;" v-for="(curItem, index) in templateData" :index="index">
					<div style="z-index:990; position:absolute; width:57px; height:57px; background:url(../static/images/publish3.png);" v-if="curItem.templatePublish==180"></div>
					<div style="z-index:991; position:absolute; width:57px; height:57px; background:url(../static/images/publish2.png);" v-if="curItem.templatePublish==181 && curItem.templateCustId==0"></div>
					<div style="z-index:992; position:absolute; width:57px; height:57px; background:url(../static/images/publish3.png);" v-if="curItem.templatePublish==181 && curItem.templateCustId!=0"></div>
					<div style="z-index:993; position:absolute; transform: rotate(-45deg) scale(0.7); left:-14px; top:10px; width:70px; height:20px; line-height:20px; border:0px solid red; color:#ffffff; text-align:center; font-size:14px;" class="DIVNoSelect">{{curItem.publish_text}}</div>

					<div style="float:left; width:253px; height:48px; line-height:30px; text-align:center; border-bottom:1px solid #bbbbbb; font-size:14px;">{{curItem.templateName}}</div>
					<table style="float:left; margin-top:-20px; width:100%; font-size:12px; color:#aaaaaa;">
						<tr><td style="text-indent:20px;">{{"size:"+curItem.width+"*"+curItem.height}}</td>
							<td style="text-indent:6px;">{{"photos:"+curItem.slice}}</td>
							<td style="text-indent:6px;">{{"times:"+curItem.templateUsedTimes}}</td></tr>
					</table>

					<TPThum :item="curItem" :key="curItem.templateId" style="background:#aaaaaa;"></TPThum>

					<div style="float:left; width:253px; height:36px; border-top:1px solid #bbbbbb; padding-top:3px;">
						<ImgThumOP :item="curItem" :ty="'5'" :dty="'tla'" :clk="onPublishClick"  style="margin-left:6px;" ></ImgThumOP>
						<ImgThumOP :item="curItem" :ty="'9'" :dty="'tla'" :clk="onEditClick"     style="margin-left:6px;" ></ImgThumOP>
						<ImgThumOP :item="curItem" :ty="'4'" :dty="'tla'" :clk="onShareSetClick" style="float:left; margin-left:6px;" ></ImgThumOP>
						<ImgThumOP :item="curItem" :ty="'8'" :dty="'tla'" :clk="onThumClick"     style="float:left; margin-left:6px;" ></ImgThumOP>
						<ImgThumOP :item="curItem" :ty="'2'" :dty="'tla'" :clk="onDelClick"      style="float:right; margin-right:6px;" ></ImgThumOP>
					</div>
				</div>
			</div>
		</div>
		<div style="flex: 0 0 auto; width:100%; height:30px; border:0px solid red;">
			<cpage :key="keyFind" :ctrl="ctrlPage" style="margin-left:0px;"></cpage>
		</div>
	</div>
</template>

<script>

import TPThum     from './TPThum'
import ImgThumOP  from './ImgThumOP'
import cpage      from '../cf/cpage'
import cselect    from '../cf/cselect'
import check      from '../cf/cck'
import popwin     from '../cf/popwin'

export default {
	name: 'TemplaList',
	components:{
		TPThum, cpage, cselect, check, ImgThumOP, popwin
	},
	data () {
		return {
			frmW: 0,
			frmH: 0,
			keyFind: 1000,
			KeyList: 2000,
			ctrlPage: {
				havNote: true,                 //是否显示提示信息
				havGo: true,                   //是否显示页号输入及按钮
				total: 0,                      //总记录数
				pageSize: 10,                  //每页记录条数
				pageIdx: 0,                     //当前页码
				cont:[LangText('共'), LangText('条记录,'), LangText('页'), LangText('条/页'), LangText('页码'),'Go'],
				qryFunc: this.onTemplaListClick,      //查询回调函数
			},
			templateData:[],
			findTemplateName: "",
			findModelType: 0,
			ctrlModelType: {
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},
			dataModelType: [ ],
			ctrlPublish: {
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10,
				Removefirst: true,
			},
			findPublish: 0,
			KeyModel: 1000,
			chkPrivate: false,
			chkShare: false,
			KeyPrivate: 2000,
			KeyShare: 3000,
			tmList: [],
			ctrlWin:{                               // 弹出窗口控制属性
				w2: 500,
				h2: 460,
				captHeight: 40,                     // 标题栏高度
				captCont: "",                       // 标题
				vuepath: "/FrameBody/TemplaList/ThumUpd",
				rcallFunc: this.onTemplaListClick,            // 指定关闭弹出窗后需要执行的回调方法
			},
		}
	},
	mounted: function(){
		if( !parseInt(this.login.userId) ) return;

		this.frmW=this.$refs["idFrmPan"].clientWidth;
		this.frmH=this.$refs["idFrmPan"].clientHeight;
		this.$refs["idListPan"].style["height"] = (this.frmH-80)+"px";
		this.$refs["idListPan"].style["width"]  = (this.frmW)+"px";

		this.findPublish   = this.$route.query.findPublish;
		this.findModelType = this.$route.query.findModelType;
		if( 0 <= (this.$route.query.findCustRange+"").indexOf("2") ) this.chkPrivate = true;
		if( 0 <= (this.$route.query.findCustRange+"").indexOf("1") ) this.chkShare = true;
		this.KeyPrivate++;
		this.KeyShare++;

		this.doTrade( "POST", ServAddr+"/api/cust/getCustInfo", this.getCustInfoOK, true, {custId: this.login.custId }, null );
	},
	computed:{

	},
	methods:{
		onResize: function(){
			this.frmW=this.$refs["idFrmPan"].clientWidth;
			this.frmH=this.$refs["idFrmPan"].clientHeight;

			if( this.frmH > 0 ) this.$refs["idListPan"].style["height"] = (this.frmH-80)+"px";
			this.$refs["idListPan"].style["width"]  = (this.frmW)+"px";

			this.childResize( this );
		},
		/* 删除模板 */
		onDelClick: function( e, item ){
			this.appRoot.app.showDlgCfm( this.DialogType.War, LangText("提示"), LangText("确定要删除吗?"), "", {okFunc:this.doTemplateDel, okParam:item} );
		},
		doTemplateDel: function( param ){
			this.doTrade( "DELETE", ServAddr+"/api/template/templateDel/"+param.templateId, this.onTemplaListClick, true, null, null );
		},
		/* 发布按钮 */
		onPublishClick: function( e, item){
			this.appRoot.app.showDlgCfm( this.DialogType.War, LangText("提示"), LangText("确定要发布吗?"), "", {okFunc:this.doTemplatePublish, okParam:item} );
		},
		doTemplatePublish: function( param ){
			this.doTrade( "PUT", ServAddr+"/api/template/publishSet/"+param.templateId, this.onTemplaListClick, true, null, null );
		},
		/* 共享模板 */
		onShareSetClick: function( e, item ){
			this.appRoot.app.showDlgCfm( this.DialogType.War, LangText("提示"), LangText("确定要共享吗?"), "", {okFunc:this.doTemplateShare, okParam:item} );
		},
		doTemplateShare: function( param ){
			this.doTrade( "PUT", ServAddr+"/api/template/shareSet/"+param.templateId, this.onTemplaListClick, true, null, null );
		},
		/* 编辑模板 */
		onEditClick: function( e, item ){
			item.findc = { findPublish:this.findPublish, findModelType:this.findModelType, findCustRange: this.getCheckValuesByName( "GrpRange") };
			this.appRoot.app.loadRouter( "/FrameBody/TemplaEdit", item );
		},
		/* 缩略图更新 */
		onThumClick: function( e, item ){
			this.ctrlWin.captCont = LangText("更新缩略图");
			this.ctrlWin.info={ tmId: item.tmId, templaId: item.templateId, templaName:item.templateName,
								templaIcon: item.templateIcon, width:item.width, height:item.height  };
			this.ctrlWin.self.onShow();
		},
		getCustInfoOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			if( data.body.custModelFlag==0 ) this.chkShare = false;
			this.KeyShare++;

			setTimeout( this.getTemplaModelList, 50 );
		},
		/* 获取模板类型列表 */
		getTemplaModelList: function(){
			let body={ custRange: 3 };
			this.doTrade( "POST", ServAddr+"/api/template/tmList", this.onTemplaModelOK, true, body, null );
		},
		onTemplaModelOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.dataModelType = [ ];
			for(let i=0; i<data.body.tmList.length; i++ )
			{
				let item=data.body.tmList[i];
				if( i==0 && this.findModelType==0 ) this.findModelType = item.tmId;   // 默认选中第一个模板类型

				this.dataModelType.push( {itemName: item.tmName, itemValue: item.tmId, subItems:[]} );
			}
			this.KeyModel++;
			this.tmList = data.body.tmList;

			this.onTemplaListClick();
		},
		onTemplaListClick: function(){
			let body={ pageSize:this.ctrlPage.pageSize, curPage:this.ctrlPage.pageIdx-1 };
			body.templateNameEng = this.findTemplateName;
			if( this.findModelType ) body.tmId = parseInt( this.findModelType ); else body.tmId = 0;
			body.templatePublish = parseInt( this.findPublish );

			let v=this.getCheckValuesByName( "GrpRange");
			if( v=="1,2" || v=="2,1" )
				 body.custRange = 3;
			else body.custRange = parseInt(v);

			this.doTrade( "POST", ServAddr+"/api/template/templateList", this.onTemplaListOK, true, body, null );
		},
		onTemplaListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.templateData = [];
			for(let i=0; i<data.body.templateList.length; i++ )
			{
				let item=data.body.templateList[i];
				let newItem={};

				newItem.templateId        = item.templateId;           // 模板ID
				newItem.templateCustId    = item.templateCustId;       // 模板所属客户
				newItem.tmId              = item.tmId;                 // 模板类型
				newItem.templatePublish   = item.templatePublish;      // 模板发布状态
				newItem.templateUsedTimes = item.templateUsedTimes;    // 模板使用次数
				newItem.templateName      = item.templateNameEng;      // 模板名称
				newItem.templateIcon      = item.templateIcon;         // 模板缩略图
				newItem.templateIconFlag  = item.templateIconFlag;     // 模板缩略图更新标志

				if( newItem.templateCustId == 0 )
					 newItem.public_text = LangText("共享");
				else newItem.public_text = LangText("私有");
				if( newItem.templatePublish == 180 )
					 newItem.publish_text = LangText("草稿");
				else newItem.publish_text = LangText("已发布");

				let json=JSON.parse( item.templateConfig );

				newItem.slice             = json.slice;                // 照片张数
				newItem.width             = json.width;                // 宽度
				newItem.height            = json.height;               // 高度
				newItem.bg                = json.bg;                   // 背景
				newItem.areas             = json.areas;                // 素材区域
				newItem.IDFlag            = json.IDFlag;               // 证件照标志, 0-不是证件照, 1-是证件照(只需要拍一张照片)
				newItem.sepa              = json.sepa ? json.sepa: 0;  // 照片切分标志

				for( let j=0; j<this.tmList.length; j++ )
				{
					if( item.tmId == this.tmList[j].tmId ) newItem.tmName = this.tmList[j].tmName;
				}

				this.templateData.push( newItem );
			}

			this.ctrlPage.total = data.body.allCnt;
			this.keyFind++;
			this.KeyList++;
		},
		onTemplateAddClick: function( ){
			let item={};
			item.templateId      = null;                  // 模板ID
			item.templateCustId  = this.login.custId;     // 模板所属客户
			item.tmId            = this.findModelType;    // 模板类型
			item.templateName    = this.getUIID();        // 模板类型名称
			item.templatePublish = 180;                   // 草稿
			item.width           = 1844;                  // 模板宽度
			item.height          = 1240;                  // 模板高度
			item.bg              = "#ffffff";             // 模板背景
			item.IDFlag          = 0;                     // 证件照标志, 0-不是证件照, 1-是证件照(只需要拍一张照片)
			item.sepa            = 0;                     // 照片分割方式, 0-不分割, 1-横向分割
			item.templateIconFlag= 0;                     // 模板缩略图更新标志
			item.areas           = [];
			for( let i=0; i<this.tmList.length; i++ )
			{
				if( item.tmId == this.tmList[i].tmId ) item.tmName = this.tmList[i].tmName;  // 模板类型名称
			}

			item.findc = { findPublish:this.findPublish, findModelType:this.findModelType, findCustRange: this.getCheckValuesByName( "GrpRange") };
			this.appRoot.app.loadRouter( "/FrameBody/TemplaEdit", item );
		},
	}
}

</script>

<style scoped>

.OP1Icon{ float:left; width:26px; height:26px; border:1px solid #47c2d0; cursor:pointer; }
.OP1Icon:hover{ opacity:0.7; }

.OP2Icon{ float:left; width:26px; height:26px; border:1px solid #c4c4c4; }

</style>



// WEBPACK FOOTER //
// TemplaList.vue?5039d88c